import React, { FC } from "react";
import { Button, ButtonProps } from "../Button/Button";
import useMediaQuery from "../../hooks/useMediaQuery";
import { Box } from "../Box/Box";
import { Portal } from "../Portal/Portal";

export const ResponsiveFixedButton: FC<ButtonProps> = ({ ...props }) => {
  const { isMobile } = useMediaQuery();

  const ButtonComponent = () => <Button {...props} />;

  return isMobile ? (
    <Portal selector="body">
      <Box
        position="fixed"
        bottom="0"
        left="0"
        right="0"
        zIndex="1"
        p="3"
        shadow="md"
        background="white"
      >
        <ButtonComponent />
      </Box>
    </Portal>
  ) : (
    <ButtonComponent />
  );
};
